module.exports = __webpack_public_path__ + "img/3_wgoods.33860c2e.jpg";